
export const getKeys = (enumType : object) => {
    return Object.keys(enumType).filter(o => isNaN(parseInt(o)));
}